import React, { useEffect, useRef, useState } from 'react'

import Upload, { UploadRef } from 'util/modules/Upload'
import { ReactComponent as Categories } from 'assets/icons/project.svg'
import { useHistory, useParams } from 'react-router-dom'
import { createAlert } from 'util/modules/Alert/redux/actions'
import { useDispatch } from 'react-redux'
import { createCategory, getCategory, updateCategory } from '../redux/actions'

const CategoryForm: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [picture, setPicture] = useState<File>()
  const uploadRef = useRef<UploadRef>(null)

  const initialState = {
    name: '',
    description: ''
  }

  const [form, setForm] = useState(initialState)
  const { id } = useParams() as { id: string }

  function handleClear (): void {
    uploadRef.current?.clear()
    setForm(initialState)
    history.push('/panel/category')
  }

  function handleSubmit (e: React.FormEvent): void {
    e.preventDefault()
    try {
      const formData = new FormData()
      if (picture) {
        formData.set('picture', picture)
      }

      formData.set('name', form.name)
      formData.set('description', form.description)

      if (id) {
        updateCategory(id, formData)(dispatch)
      } else {
        createCategory(formData)(dispatch).then(res => {
          if (res?.status === 'success') {
            handleClear()
          }
        })
      }
    } catch (error) {
      createAlert({ code: 500, title: 'Oops', message: error.message })(dispatch)
    }
  }

  useEffect(() => {
    if (id) {
      getCategory(id)(dispatch).then(res => {
        if (res?.status === 'success' && res.data) {
          const category = res.data
          setForm({
            name: category.name,
            description: category.description || ''
          })

          uploadRef.current?.setPreviewImage(category.pictureMedium)
        }
      })
    } else {
      handleClear()
    }

    // eslint-disable-next-line
  }, [id, dispatch])

  return (
    <form className="row panel category-form" onSubmit={handleSubmit}>
      <div className="row justify-start margin-bottom-8 mobile-center-category">
        <h2><Categories height="20" width="35" />Categorias</h2>
      </div>

      <div className="row category-colum margin-top-16">
        <div style={{ width: 170, height: 170 }}>
          <Upload
            ref={uploadRef}
            onChange={setPicture}
            placeholder="Selecionar imagem para categoria"
          />
        </div>
        <div className="row grow padding-left-8" style={{ marginTop: -16 }}>
          <div className="row">
            <div className="form-control">
              <label>Nome</label>
              <input
                type="text"
                value={form.name}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, name: value }))}
                required
              />
            </div>
            <div className="form-control">
              <label>Descrição</label>
              <input
                type="text"
                value={form.description}
                onChange={({ target: { value } }): void => setForm(form => ({ ...form, description: value }))}
              />
            </div>
          </div>

        </div>

        <div className="row justify-end margin-top-16">
          <span className="button secondary" onClick={handleClear} style={{ width: 300 }}>
            Limpar
          </span>
          <button className="button primary margin-left-8" style={{ width: 300 }}>Salvar</button>
        </div>

      </div>
    </form>
  )
}

export default CategoryForm
